import React from "react";
import { useQuery } from "@tanstack/react-query";
import { backendApi } from "@/api/backendApi";
import { Eye, Download, Star, Info } from "lucide-react";

export default function RecruiterActivityWidget() {
    const { data: analytics } = useQuery({
        queryKey: ["dashboard", "analytics"],
        queryFn: () => backendApi.entities.Dashboard.analytics(),
        staleTime: 60000,
        enabled: !!backendApi.auth.getToken(),
    });

    const activities = analytics?.recruiterActivities || [];

    const getIconInfo = (type) => {
        switch (type) {
            case 'view': return { icon: <Eye className="w-4 h-4 text-blue-500" />, bg: "bg-blue-50" };
            case 'download': return { icon: <Download className="w-4 h-4 text-green-500" />, bg: "bg-green-50" };
            case 'shortlist': return { icon: <Star className="w-4 h-4 text-yellow-500" />, bg: "bg-yellow-50" };
            default: return { icon: <Info className="w-4 h-4 text-gray-500" />, bg: "bg-gray-50" };
        }
    };

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 mb-6">
            <h3 className="text-gray-900 font-semibold mb-4">Recruiter Activity</h3>

            <div className="space-y-4">
                {activities.length > 0 ? (
                    activities.map((activity, index) => {
                        const { icon, bg } = getIconInfo(activity.activity_type);
                        return (
                            <div key={index} className="relative flex gap-3 pb-4">
                                {/* Timeline line */}
                                {index !== activities.length - 1 && (
                                    <div className="absolute top-8 left-4 bottom-0 w-px bg-gray-100" />
                                )}

                                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 z-10 ${bg}`}>
                                    {icon}
                                </div>

                                <div className="overflow-hidden">
                                    <p className="text-sm text-gray-800 leading-tight mb-1 truncate">{activity.message}</p>
                                    <p className="text-xs text-gray-400 font-medium">🕒 {new Date(activity.created_at).toLocaleDateString()}</p>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="text-center py-6 text-sm text-gray-500 bg-gray-50 rounded-lg border border-dashed border-gray-200">
                        No recent recruiter activity to show.
                    </div>
                )}
            </div>

            <button className="w-full text-center text-sm font-semibold text-blue-600 mt-2 hover:underline">
                View all recruiters
            </button>
        </div>
    );
}
